export default __webpack_public_path__ + "static/wreath-5d9eb4360505d9cbd249745b79c58f6f.mp4";